// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchBox-cls1_xgk","cls2":"SearchBox-cls2_lZJ SearchBox-cls1_xgk"};